export default "__VITE_ASSET__b28672a0__"